/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import store from 'store';
import {
  LOCAL_STORAGE_AUTH_KEY,
  //  APIM_SUBSCRIPTION_KEY
} from '../config/constants';
// import { CONNECT_SUBSCRIPTION_KEY } from '../config/auth0'

/**
 *
 * using basic auth
 */
// const username = 'test';
// const password = 'safelywith';
// const BASE_URL = process.env.REACT_APP_BACKEND;
// const encodedString = (value) => Buffer.from(value).toString('base64');
// const AUTHORIZATION = `Basic ${encodedString(`${username  }:${  password}`)}`;

export const authorizeHeader = (config) => {
  const accessToken = `Bearer ${store.get(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN)}`;
  // const accessToken = AUTHORIZATION;

  if (config && config.headers) {
    config.headers = {
      ...config.headers,
      Authorization: accessToken,
      // 'Ocp-Apim-Subscription-Key': APIM_SUBSCRIPTION_KEY,
    };
  } else {
    config.headers = {
      ...config.headers,
      Authorization: accessToken,
      // 'Ocp-Apim-Subscription-Key': APIM_SUBSCRIPTION_KEY,
    };
  }
  return config;
};
